import { getAccountPermissions, getUserOktaStatusDef } from '../../../../backend/features/accounts/shared';
import { requireAnySystemPermission } from '../../../../backend/features/permissions/shared';
import { userDirectoryGetDef } from '../../../../backend/features/user-directory/shared';
import { useAccountSlideoutMenuItems } from '../../../../ui/features/accounts/hooks';
import { UserDirectoryAccountDetails, } from '../../../../ui/features/user-directory/components/UserDirectoryAccountDetails';
import { useUserState } from '../../../../ui/hooks';
import { ContactManagementConfigContext } from '../../../../ui/providers';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { ModalSlideout, useModalSlideoutScroll } from '@juvare/common-web-ui/ModalSlideout';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { PartialError } from '@juvare/common-web-ui/PartialError';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useTypedPlatformFunctionResponse } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
export const UserDirectorySlideout = ({ accountId, ariaSlideoutContentId, hideDefaultMenuItems, customDetailsComponent, onClose, customMenuItems, accountListReload, }) => {
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const settings = useSelector(getSettings);
    const userState = useUserState();
    const { userDirectoryTableCustomization } = React.useContext(ContactManagementConfigContext);
    const { isScrolledToTop, handleScroll, handleResetScroll } = useModalSlideoutScroll();
    const handleClose = (changed) => {
        handleResetScroll();
        onClose(changed);
    };
    const { data: accountResponse, isLoading: accountIsLoading, error: accountError, mutate: accountReload, } = useTypedPlatformFunctionResponse(userDirectoryGetDef, accountId ? { accountId: accountId } : undefined);
    const account = accountResponse;
    const loadOktaStatus = (account === null || account === void 0 ? void 0 : account.data) &&
        settings.identityProvider.oktaActionsEnabled &&
        requireAnySystemPermission(userState, 'allow-reset-okta-password-email', 'allow-reset-okta-mfa', 'allow-unlock-okta-account', 'allow-change-login-email');
    const { data: oktaStatus, isLoading: oktaStatusLoading, error: oktaStatusError, mutate: mutateOktaStatus, } = useTypedPlatformFunctionResponse(getUserOktaStatusDef, loadOktaStatus && account && accountId ? { accountId: accountId } : undefined);
    const error = accountError !== null && accountError !== void 0 ? accountError : oktaStatusError;
    const loading = oktaStatusLoading || accountIsLoading;
    const defaultAccountMenuItems = useAccountSlideoutMenuItems({
        account,
        accountReload,
        accountListReload,
        mutateOktaStatus,
        oktaStatus,
        handleClose,
    });
    if (!accountId || loading || !accountResponse) {
        return null;
    }
    const accountPermissions = getAccountPermissions(settings, userState, accountId, account.data);
    const getMenuItems = () => {
        const menuItems = [];
        if (!hideDefaultMenuItems) {
            menuItems.push(...defaultAccountMenuItems);
        }
        return customMenuItems ? customMenuItems({ account, menuItems, onClose, accountReload, accountListReload }) : menuItems;
    };
    const UserDirectoryDetailsComponent = customDetailsComponent !== null && customDetailsComponent !== void 0 ? customDetailsComponent : UserDirectoryAccountDetails;
    return (React.createElement(ModalSlideout, { ariaContentId: ariaSlideoutContentId, open: !!accountId, onClose: () => handleClose(false), "data-test": 'account-slideout' },
        React.createElement(Box, { onScroll: handleScroll, sx: {
                overflow: 'auto',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: themeColors.surface.primary,
            } },
            account && !accountError && (React.createElement(UserDirectoryDetailsComponent, { isScrolledToTop: isScrolledToTop, account: account, accountPermissions: accountPermissions, onViewProfile: () => navigationContext.navigate(() => {
                    if (userDirectoryTableCustomization === null || userDirectoryTableCustomization === void 0 ? void 0 : userDirectoryTableCustomization.onNavigateToAccount) {
                        userDirectoryTableCustomization.onNavigateToAccount(accountId);
                    }
                    else {
                        navigate(`/accounts/${accountId}`, { state: { back: true } });
                    }
                }), onClose: handleClose, menuItems: getMenuItems().map((item) => {
                    var _a;
                    return ({
                        label: item.label,
                        onClick: (_a = item.onClick) !== null && _a !== void 0 ? _a : (() => undefined),
                        'data-test': item['data-test'],
                    });
                }) })),
            accountIsLoading && !error && React.createElement(CircularProgress, null),
            !!error && React.createElement(PartialError, { error: error }))));
};
